module.exports = __webpack_public_path__ + "static/media/flash_card.d4034b1c.svg";